import OnboardingInput from "@/components/pages/onboarding/components/onboarding-input";
import styles from "@/components/modal/onboarding-input-modal/styles/onobarding-input-modal.module.scss";

const OnboardingInputModal = () => {
  return (
    <div className={styles.wrapper}>
      <OnboardingInput />
    </div>
  );
};

export default OnboardingInputModal;
